import { Component, OnDestroy, OnInit } from '@angular/core';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { EventService } from '@app/event/event.service';
import { UserService } from '@app/user/user.service';
import { ModalService } from '@app/shared/modal/modal.service';
import { RoutingService } from '@app/routing.service';
import { ActivatedRoute } from '@angular/router';
import { ResponsiveService } from '@app/utility/responsive.service';
import gql from 'graphql-tag';
import { Apollo, QueryRef } from 'apollo-angular';
import { translateLanguages } from '@app/translateLanguages';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { CurrentUserGQL } from '@app/graphql/generated';
import { BehaviorSubject, combineLatest, of } from 'rxjs';
import { EventTranscodersService } from '@app/shared/pages/event-transcoders/event-transcoders.service';
import { ElectronService } from 'ngx-electron';

@Component({
  selector: 'app-event-transcoders',
  templateUrl: './event-transcoders.component.html',
  styleUrls: ['./event-transcoders.component.scss']
})
export class EventTranscodersComponent implements OnInit, OnDestroy {
  public event$ = this.eventTranscodersService.event;

  userAddedEncoders;

  public languagesDropdown = translateLanguages.map(lang => ({
    label: lang.name,
    value: lang.code
  }));

  public yesNoDropdown = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ];

  public encoderStatusDropdown = [
    { label: 'Offline', value: false },
    { label: 'Online', value: true }
  ];

  public encoders = this.eventTranscodersService.event.pipe(
    map(event => this.mapEncodersToFormGroups(event.transcoders))
  );

  public subToEncoderOutput = this.encoders.pipe(
    untilDestroyed(this),
    switchMap(encoderFormGroups => {
      return combineLatest(
        encoderFormGroups.map(eventEncoder => {
          const formGroup = eventEncoder.formGroup;

          const enabled = formGroup.get('enabled').value;
          const ip = eventEncoder.ip;

          if (ip === '127.0.0.1' && enabled === true) {
            return (
              eventEncoder.encoderOutput$.pipe(
                untilDestroyed(this),
                tap(words => {

                  console.log('send to icap');
                  this.sendToICap(words);
                })
              ) || of('')
            );
          } else {
            return of('');
          }
        })
      );
    })
  );

  constructor(
    private currentUserGQL: CurrentUserGQL,
    public eventService: EventService,
    private fb: FormBuilder,
    private userService: UserService,
    private appModalService: ModalService,
    private routingService: RoutingService,
    private route: ActivatedRoute,
    public responsiveService: ResponsiveService,
    private apollo: Apollo,
    private eventTranscodersService: EventTranscodersService,
    private _electronService: ElectronService
  ) {
  }

  ngOnInit() {
    this.eventTranscodersService.updateEventId(
      this.route.snapshot.params.eventId
    );

    this.userAddedEncoders = [];
    this.eventTranscodersService.getUserEncoders().subscribe(encoders => {
      encoders.map(encoder => {
        this.userAddedEncoders.push(({ label: `${encoder.name}`, value: encoder.uuid}));
      });
      
      this.subToEncoderOutput.subscribe();
    });
  }

  sendToICap(message) {
    if (this._electronService.isElectronApp) {
      // @ts-ignore
      const pong: string = window.electronAPI.sendToIcap(
        { port: 9740, message }
      );
    }
  }

  mapEncodersToFormGroups(encoders) {
    return encoders.map(transcoder => {
      const group = this.fb.group({
        language: this.fb.control(transcoder.language),
        enabled: this.fb.control(transcoder.enabled),
        encoderId: this.fb.control(
          transcoder.encoder && transcoder.encoder.uuid
        ),
        eventEncoderId: this.fb.control(transcoder.uuid)
      });

      group.valueChanges.subscribe(() => {
        this.save(group.value);
      });

      return { formGroup: group, ...transcoder };
    });
  }

  addTranscoder() {
    this.eventTranscodersService.createEncoder();
  }

  save(encoder) {
    this.eventTranscodersService.updateEncoder(encoder);
  }

  removeTranscoder(uuid: any) {
    this.eventTranscodersService.removeEncoder(uuid);
  }

  ngOnDestroy(): void {
  }
}
